(function () {
  const ATTR = 'Digital content waiver (EU Art. 16m)';
  const ERROR_ID = 'digital-content-waiver-error';

  function cartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) {
      return window.routes.cart_update_url;
    }
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + 'cart/update.js';
  }

  function fetchConfig() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
  }

  function isAccepted() {
    const checkbox = document.getElementById('digital-content-waiver');
    return !!(checkbox && checkbox.checked);
  }

  function showError(show) {
    const error = document.getElementById(ERROR_ID);
    if (error) {
      error.hidden = !show;
    }
  }

  function syncAttribute(checked) {
    return fetch(cartUpdateUrl(), {
      ...fetchConfig(),
      body: JSON.stringify({
        attributes: {
          [ATTR]: checked ? 'Yes' : 'No',
        },
      }),
    });
  }

  // Express checkout buttons (Shop Pay, PayPal...) bypass Check out, so they appear only once the cart has saved the waiver.
  // Writes go one at a time, so an older write can never land after a newer one.
  let latest = 0;
  let pending = 0;
  let queue = Promise.resolve();
  function applyState(checked) {
    const request = ++latest;
    pending++;
    document.documentElement.classList.remove('dcw-accepted');
    queue = queue
      .then(function () {
        if (request !== latest) {
          return;
        }
        return syncAttribute(checked).then(function (response) {
          if (request === latest && response.ok && checked && isAccepted()) {
            document.documentElement.classList.add('dcw-accepted');
          }
        });
      })
      .catch(function () {})
      .then(function () {
        pending--;
      });
    return queue;
  }

  function validate(event) {
    if (!isAccepted()) {
      event.preventDefault();
      event.stopPropagation();
      showError(true);
      return;
    }
    showError(false);

    // A waiver write still in flight lands before the order starts
    if (pending > 0) {
      event.preventDefault();
      event.stopPropagation();
      queue.then(function () {
        const form = document.getElementById('cart');
        const button = document.getElementById('checkout');
        if (form && form.requestSubmit) {
          form.requestSubmit(button && button.form === form ? button : undefined);
        } else if (form) {
          form.submit();
        }
      });
    }
  }

  function bind() {
    const checkbox = document.getElementById('digital-content-waiver');
    if (!checkbox) {
      return;
    }

    // EU Art. 16(m): waiver must be an active opt-in, never pre-checked.
    checkbox.checked = false;
    applyState(false);

    // Delegated listeners keep working if the theme re-renders the cart footer
    document.addEventListener('change', function (event) {
      if (event.target && event.target.id === 'digital-content-waiver') {
        showError(false);
        applyState(event.target.checked);
      }
    });

    document.addEventListener(
      'click',
      function (event) {
        if (event.target.closest && event.target.closest('[name="checkout"], #checkout')) {
          validate(event);
        }
      },
      true
    );

    const cartForm = document.getElementById('cart');
    if (cartForm) {
      cartForm.addEventListener('submit', validate, true);
    }

    // A re-rendered footer brings a fresh, unticked box
    const footer = document.getElementById('main-cart-footer');
    if (footer && window.MutationObserver) {
      let current = checkbox;
      new MutationObserver(function () {
        const box = document.getElementById('digital-content-waiver');
        if (box && box !== current) {
          current = box;
          applyState(box.checked);
        }
      }).observe(footer, { childList: true, subtree: true });
    }

    // Back navigation restores the page from cache without running this again
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        applyState(isAccepted());
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
